import { useEffect, useState } from "react";
import { Box, Skeleton, Tab, Tabs, Typography } from "@mui/material"
import { DataGrid } from '@mui/x-data-grid';
import { useParams, useSearchParams } from "react-router-dom";
import { useFetchData } from "../../hooks/useFetchData";
import { UBHourlyFilter as UBErrorFilter } from "./UBHourlyFilter";
import moment from "moment";
import { shortenNumber } from "../../utils/number";

const columns = [
    { field: 'message', headerName: 'Message', minWidth: 500, align: "left"},
    { field: 'count_00', headerName: '0', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_01', headerName: '1', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_02', headerName: '2', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_03', headerName: '3', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_04', headerName: '4', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_05', headerName: '5', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_06', headerName: '6', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_07', headerName: '7', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_08', headerName: '8', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_09', headerName: '9', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_10', headerName: '10', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_11', headerName: '11', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_12', headerName: '12', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_13', headerName: '13', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_14', headerName: '14', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_15', headerName: '15', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_16', headerName: '16', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_17', headerName: '17', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_18', headerName: '18', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_19', headerName: '19', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_20', headerName: '20', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_21', headerName: '21', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_22', headerName: '22', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_23', headerName: '23', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)}
];

const rows = [
];

const UBErrorSkeleton = () => {
    return (
        <><Skeleton /><Skeleton /><Skeleton /></>
    );
};

export const UBError = () => {
    const { dashboard: pDashboard } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();

    const [date, setDate] = useState(moment(searchParams.get("date") ?? new Date()));
    const [dateFormatted, setDateFormatted] = useState({
        date: date.format("YYYY-MM-DD"),
    });
    const [tabIndex, setTabIndex] = useState(0);

    const handleTabChange = (event, newTabIndex) => {
        setTabIndex(newTabIndex);
        searchParams.set("categoryName", categoriesData[newTabIndex]?.category_name);
        setSearchParams(searchParams);
    };

    const { status: categoriesStatus, data: categoriesData } = useFetchData({
        endpoint: `unionbank/${pDashboard}/categories/message`,
        defaultData: []
    });

    const { status: errorStatus, data: errorData } = useFetchData({
        endpoint: `unionbank/${pDashboard}/24hours/message`,
        params: dateFormatted,
        defaultData: []
    });

    useEffect(() => {
        setDateFormatted({
            date: date.format("YYYY-MM-DD"),
        })
    }, [date]);

    useEffect(() => {
        if (categoriesStatus === "resolved") {
            const index = categoriesData?.findIndex(category => category?.category_name === searchParams.get("categoryName")); 
            setTabIndex(index === -1 ? 0 : index);
        }
    }, [categoriesData, categoriesStatus, searchParams]);

    useEffect(() => {
        searchParams.set("date", date);
        setSearchParams(searchParams);
    }, [date, searchParams, setSearchParams]);

    return (
        <Box
            container
            minHeight="95vh"
            height="100%"
            sx={{
                p: 1
            }}
        >
            <Box>
                <UBErrorFilter value={date} onChange={setDate} />
            </Box>

            {categoriesStatus === "loading" ? <UBErrorSkeleton/> :
                <>
                    <Box sx={{ borderBottom: 1, my: 5, borderColor: 'divider', width: "100%"}}>
                        <Tabs value={tabIndex} onChange={handleTabChange} variant="scrollable" aria-label="error data tabs">
                            {categoriesData?.map((category, index) => {
                                return <Tab sx={{ color: 'white', borderColor: 'white', fontSize: 16, fontWeight: "bold", textTransform: "none", whiteSpace: "nowrap", maxWidth: 1000 }} label={category?.category_label} key={`tab-${category?.category_id}-${index}`} id={`simple-tab-${index}`} aria-controls={`simple-tabpanel-${index}`} />;
                            })}
                        </Tabs>
                    </Box>

                    {categoriesData?.map((category, index) => {
                        return (
                            <Box role="tabpanel" sx={{ width: "100%" }} hidden={tabIndex !== index} key={`tab-panel-${category?.category_id}-${index}`} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`}>
                                {errorStatus === "loading" ? <UBErrorSkeleton /> :
                                    errorData?.filter(event => event?.category_id === category?.category_id)?.map(event => {
                                        return event?.channels?.length > 0 ? (
                                            event?.channels?.map(channel => {
                                                return (
                                                    <Box key={`event-data-${event?.event_id}-${channel?.channel_id}`} sx={{ py: 1, width: "100%" }}>
                                                        <Typography
                                                            variant="h6"
                                                            fontWeight="bold"
                                                            gutterBottom align="left"
                                                        >
                                                            {channel?.channel_name === "default" ? event?.event_label : `${event?.event_label} - ${channel?.channel_label}`}
                                                        </Typography>

                                                        <DataGrid
                                                            title=""
                                                            rows={channel?.messages?.map((message, index) => {
                                                                return {
                                                                    id: index,
                                                                    message: message?.message,
                                                                    ...message?.error
                                                                };
                                                            })}
                                                            columns={columns}
                                                            hideFooter
                                                            autoHeight
                                                        />
                                                    </Box>
                                                )
                                            })
                                        ) : (
                                            <Box key={`event-data-${event?.event_id}`} sx={{ py: 1, width: "100%" }}>
                                                <Typography
                                                    variant="h6"
                                                    fontWeight="bold"
                                                    gutterBottom align="left"
                                                >
                                                    {`${event?.event_label}`}
                                                </Typography>
                                                    
                                                <DataGrid
                                                    title=""
                                                    rows={rows}
                                                    columns={columns}
                                                    hideFooter
                                                    autoHeight
                                                />
                                            </Box>
                                        );
                                    })
                                }
                            </Box>
                        );
                    })}
                </>
            }
        </Box>
    );
}